import { render, staticRenderFns } from "./TrInput.vue?vue&type=template&id=bf3ff6e2&scoped=true&"
import script from "./TrInput.vue?vue&type=script&lang=js&"
export * from "./TrInput.vue?vue&type=script&lang=js&"
import style0 from "./TrInput.vue?vue&type=style&index=0&id=bf3ff6e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3ff6e2",
  null
  
)

export default component.exports